const Section = ({ children, className = "", background = "white" }) => {
  const backgrounds = {
    white: "bg-white",
    gray: "bg-gray-50",
    primary: "bg-primary-50",
  }

  return (
    <section className={`section-padding ${backgrounds[background]} ${className}`}>
      <div className="container-custom">{children}</div>
    </section>
  )
}

export default Section
